export const CHANGE_SUBJECT = "CHANGE_SUBJECT";
export const PROGRESS_START = "PROGRESS_START";

export const TOGGLE_OPEN = "TOGGLE_OPEN";
export const SEARCH_COMPONENT = "SEARCH_COMPONENT";
